/*
 * 充电桩 — 与 chargePile 共用资源，类型标识为 chargeStation
 */
import { GraphElement } from '../graph-element.js'
import { createFromJSON } from './help.js'

class ChargeStationElement extends GraphElement {
  static fromJSON = createFromJSON(this)

  constructor(topology, x, y, attrs) {
    super(topology, 'chargeStation', x, y, {
      text: '充电桩',
      port: true,
      ...attrs,
    })
  }
}

export { ChargeStationElement }
